import React, { forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import FormatListNumberedRtl from '@material-ui/icons/FormatListNumberedRtl';

const TypeItemSort = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <FormatListNumberedRtl {...props} ref={ref} />
));

TypeItemSort.displayName = 'TypeItemSort';

export default TypeItemSort;
